import { render, staticRenderFns } from "./shutdown.vue?vue&type=template&id=484d4356&scoped=true&"
import script from "./shutdown.vue?vue&type=script&lang=js&"
export * from "./shutdown.vue?vue&type=script&lang=js&"
import style0 from "./shutdown.vue?vue&type=style&index=0&id=484d4356&lang=scss&scoped=true&"
import style1 from "./shutdown.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484d4356",
  null
  
)

export default component.exports